import { useEffect, useState } from 'react';
import { PRICING_API_URL } from '../constants';
import { parsePricing, type PricingPlan } from '../lib/pricing';

type PricingState = { status: 'loading' | 'error'; plans: PricingPlan[] } | { status: 'ready'; plans: PricingPlan[] };

export function usePricing() {
  const [state, setState] = useState<PricingState>({ status: 'loading', plans: [] });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    let active = true;
    async function load() {
      try {
        const response = await fetch(import.meta.env.VITE_PRICING_API_URL || (import.meta.env.DEV ? '/billing/public/pricing' : PRICING_API_URL), { signal: controller.signal });
        if (!response.ok) throw new Error(`Pricing request failed: ${response.status}`);
        const plans = parsePricing(await response.json());
        if (active) setState({ status: 'ready', plans });
      } catch {
        if (active) setState({ status: 'error', plans: [] });
      } finally {
        clearTimeout(timeout);
      }
    }
    void load();
    return () => { active = false; clearTimeout(timeout); controller.abort(); };
  }, [attempt]);
  return { ...state, retry: () => { setState({ status: 'loading', plans: [] }); setAttempt(value => value + 1); } };
}
